import API from "../../../hooks/api";
import {
  PRE_ELIGIBILITY_HOURLY_DATA_URL,
  SALES_DROP_URL,
  STAGE_WISE_HOURLY_DATA_URL,
} from "../../../utils/Endpoints";

const { REACT_APP_BASE_URL } = process.env;

export interface StageWiseApiRow {
  hourRange: string;
  created?: number;
  locked?: number;
  salaryCheck?: number;
  verified?: number;
  parkingStage?: number;
  hardRejected?: number;
  commodityPurchasedRequested?: number;
  commodityPurchased?: number;
  appCustcared?: number;
  callInitializedUnique?: number;
  callInitialized?: number;
  callApproved?: number;
  contractSigned?: number;
  sanadCreated?: number;
  nafaesSalesOrdered?: number;
  disbursed?: number;
  withdrawalRequested?: number;
  withdrawalSuccess?: number;
  preloanEligibility?: number;
  preloanToCreatedDropPercent?: number;
  createdToVerifiedPercent?: number;
  verifiedToAppCustcaredPercent?: number;
  appCustcaredToCallInitializedPercent?: number;
  callInitializedToCallApprovedPercent?: number;
  callApprovedToContractSignedPercent?: number;
  contractSignedToSanadCreatedPercent?: number;
  sanadCreatedToNafaesSalesOrderedPercent?: number;
  preloanToCreatedAlert?: number;
  createdToVerifiedAlert?: number;
  verifiedToAppCustcaredAlert?: number;
  appCustcaredToCallInitializedAlert?: number;
  callInitializedToCallApprovedAlert?: number;
  callApprovedToContractSignedAlert?: number;
  contractSignedToSanadCreatedAlert?: number;
  sanadCreatedToNafaesSalesOrderedAlert?: number;
}

export interface PreEligibilityApiRow {
  hourRange: string;
  totalPreEligibility?: number;
  preRegistration?: number;
  eligibleCount?: number;
  notEligbileCount?: number;
  notEligibleCount?: number;
  postRegistration?: number;
  middlewareCustomerBlock?: number;
  eligiblePercent?: number;
  notEligiblePercent?: number;
}

export interface SalesDropApiResponse {
  preloanToCreatedDropPercent: number;
  preloanToCreatedAlert: number;
  createdToVerifiedDropPercent: number;
  createdToVerifiedAlert: number;
  verifiedToAppCustcaredDropPercent: number;
  verifiedToAppCustcaredAlert: number;
  appCustcaredToCallInitializedDropPercent: number;
  appCustcaredToCallInitializedAlert: number;
  callInitializedToCallApprovedDropPercent: number;
  callInitializedToCallApprovedAlert: number;
  callApprovedToContractSignedDropPercent: number;
  callApprovedToContractSignedAlert: number;
  contractSignedToSanadCreatedDropPercent: number;
  contractSignedToSanadCreatedAlert: number;
  sanadCreatedToNafaesSalesOrderedDropPercent: number;
  sanadCreatedToNafaesSalesOrderedAlert: number;
  preloanEligibilityCount: number;
  createdCount: number;
  verifiedUniqueCount: number;
  appCustcaredCount: number;
  callInitializedUniqueCount: number;
  callApprovedUniqueCount: number;
  contractSignedUniqueCount: number;
  sanadCreatedUniqueCount: number;
  nafaesSalesOrderedCount: number;
  disbursedCount: number;
  withdrawalRequestedCount: number;
  withdrawalSuccessCount: number;
}

export const getStageWiseHourlyData = async (
  signal?: AbortSignal
): Promise<StageWiseApiRow[]> => {
  const response = await API.get(REACT_APP_BASE_URL + STAGE_WISE_HOURLY_DATA_URL, {
    signal,
    skipGlobalLoader: true,
  });
  return (response.data ?? []) as StageWiseApiRow[];
};

export const getPreEligibilityHourlyData = async (
  signal?: AbortSignal
): Promise<PreEligibilityApiRow[]> => {
  const response = await API.get(REACT_APP_BASE_URL + PRE_ELIGIBILITY_HOURLY_DATA_URL, {
    signal,
    skipGlobalLoader: true,
  });
  return (response.data ?? []) as PreEligibilityApiRow[];
};

export const getSalesDropData = async (
  signal?: AbortSignal
): Promise<SalesDropApiResponse | null> => {
  const response = await API.get(REACT_APP_BASE_URL + SALES_DROP_URL, {
    signal,
    skipGlobalLoader: true,
    // Sales-drop is optional for this screen; swallow HTTP errors for this API only
    // so global interceptor modal is not triggered.
    validateStatus: () => true,
  });

  if (response.status < 200 || response.status >= 300) {
    return null;
  }

  return (response.data ?? {}) as SalesDropApiResponse;
};
